
import ProductCard, { Product } from './ProjectCard';

const products: Product[] = [
  {
    id: 'mentoria',
    priority: 'P1',
    category: 'Consultoria',
    title: 'Mentoria IA para Negócios',
    tagline: 'Implementação estratégica de IA em 90 dias para empresários que faturam R$ 50k+/mês.',
    description: '12 sessões individuais, método PPA (Prosseguindo Para o Alvo), automações funcionando — não teoria. Potencial de gerar R$ 250k+ em valor no primeiro ano. O cliente não fica sozinho testando o que não funciona.',
    tags: ['Consultoria', 'IA', '90 dias', 'B2B', 'Automação'],
    site: '/mentoria',
    whatsapp: 'https://wa.me/5516997787674',
    featured: true,
  },
  {
    id: 'busca-rapida',
    priority: 'P1',
    category: 'SaaS',
    title: 'BuscaRápida',
    tagline: 'Automação de consultas de estoque via WhatsApp — resposta em menos de 2 segundos, sem treinar nada.',
    description: 'Integração nativa com Linx e Bling. Busca heurística: tela, frontal e display são a mesma peça — o sistema já sabe. Atendimento 24/7, multi-filial, LGPD. Implantação 100% assistida.',
    tags: ['WhatsApp', 'Automação', 'SaaS', 'Linx', 'Bling'],
    site: 'https://buscarapida.online',
    whatsapp: 'https://wa.me/5516997787674',
    featured: true,
  },
  {
    id: 'cod2d',
    priority: 'P2',
    category: 'SaaS · Compliance',
    title: 'Cod2D — GS1 Digital Link',
    tagline: 'Converte EAN-13 para o padrão GS1 Digital Link exigido pelas grandes redes a partir de 2027.',
    description: 'Sunrise 2027: fabricantes que não se adequarem perdem acesso às prateleiras de Carrefour, Walmart e grandes redes globais. API REST com integração em menos de 1h. Página pública por produto com rastreabilidade.',
    tags: ['GS1', 'QR Code', 'API', 'Sunrise 2027', 'Indústria'],
    site: 'https://cod2d.com.br',
    whatsapp: 'https://wa.me/5516997787674',
  },
  {
    id: 'plataforma-white-label',
    priority: 'P2',
    category: 'Plataforma · EAD',
    title: 'Plataforma de Cursos White-Label',
    tagline: 'EAD completo com sua marca, IA Coach integrado e 37 cursos prontos para publicar.',
    description: '100% White-Label — sua marca, cores, domínio. O aluno não sabe que a plataforma existe. Setup em menos de 7 dias. Multi-tenant, certificação automática, gamificação e suporte mensal incluídos.',
    tags: ['EAD', 'White-Label', 'IA Coach', 'B2B', 'SaaS'],
    whatsapp: 'https://wa.me/5516997787674',
  },
  {
    id: 'analise-cognitiva',
    priority: 'P2',
    category: 'Serviço',
    title: 'Análise Cognitiva',
    tagline: 'Mapeamento comportamental e cognitivo aplicado a pessoas e empresas — resultado prático, não só relatório.',
    description: 'Para pessoas: autoconhecimento, padrões TDAH, decisões de carreira. Para empresas (RH): seleção com precisão comportamental, composição de times de alta performance, identificação de lideranças internas.',
    tags: ['Comportamental', 'TDAH', 'RH', 'Carreira', 'Liderança'],
    whatsapp: 'https://wa.me/5516997787674',
  },
  {
    id: 'cursos',
    priority: 'P2',
    category: 'Educação Online',
    title: 'Cursos de Crescimento',
    tagline: 'Biblioteca de 38 cursos online em 6 categorias: mente, ação, liderança, autoconhecimento, bem-estar e prosperidade.',
    description: 'Autodirigido, 100% online, acesso vitalício. Disponível também para empresas como benefício de capacitação de equipes — com plataforma white-label própria.',
    tags: ['Cursos Online', 'Desenvolvimento', 'EAD', 'Liderança', 'Mente'],
    site: '/mentoria',
  },
  {
    id: 'desenvolvimento',
    priority: 'P2',
    category: 'Parceria · SaaS',
    title: 'Desenvolvimento de Sistemas',
    tagline: 'Parceria 50/50: você entra com a ideia, Johnny Vaz entra com a execução técnica.',
    description: 'Desenvolvemos um SaaS real juntos. Johnny tem skin in the game — quer que o produto funcione tanto quanto você. Começa pela Mentoria IA para validar o negócio antes de escrever uma linha de código.',
    tags: ['SaaS', 'Parceria 50/50', 'Desenvolvimento', 'IA'],
    whatsapp: 'https://wa.me/5516997787674',
  },
];

const ProjectsList = () => {
  const p1 = products.filter((p) => p.priority === 'P1');
  const p2 = products.filter((p) => p.priority === 'P2');

  return (
    <section style={{ backgroundColor: '#0B0B0B' }}>

      {/* Label de contexto */}
      <div
        className="container mx-auto px-6"
        style={{ paddingTop: '1rem', paddingBottom: '3rem' }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            borderBottom: '1px solid rgba(242,237,227,0.1)',
            paddingBottom: '1.5rem',
          }}
        >
          <span
            style={{
              fontFamily: "'JetBrains Mono', ui-monospace, monospace",
              fontSize: '0.65rem',
              letterSpacing: '0.12em',
              textTransform: 'uppercase' as const,
              color: '#FF4500',
            }}
          >
            P1 — Prioridade máxima
          </span>
          <span style={{ color: 'rgba(242,237,227,0.15)', fontSize: '0.75rem' }}>·</span>
          <span
            style={{
              fontFamily: "'JetBrains Mono', ui-monospace, monospace",
              fontSize: '0.65rem',
              letterSpacing: '0.12em',
              textTransform: 'uppercase' as const,
              color: '#8C8377',
            }}
          >
            P2 — Em desenvolvimento / disponível
          </span>
        </div>
      </div>

      {/* Grid P1 — featured, full-width each */}
      <div className="container mx-auto px-6" style={{ paddingBottom: '2rem' }}>
        <div style={{ display: 'grid', gap: '2px' }}>
          {p1.map((product, i) => (
            <ProductCard key={product.id} product={product} index={i} />
          ))}
        </div>
      </div>

      {/* Divisor */}
      <div className="container mx-auto px-6">
        <div
          style={{
            borderTop: '1px solid rgba(242,237,227,0.08)',
            marginBottom: '2rem',
            paddingTop: '2rem',
          }}
        >
          <span
            style={{
              fontFamily: "'JetBrains Mono', ui-monospace, monospace",
              fontSize: '0.65rem',
              letterSpacing: '0.12em',
              textTransform: 'uppercase' as const,
              color: '#8C8377',
            }}
          >
            P2 — Produtos e serviços
          </span>
        </div>
      </div>

      {/* Grid P2 — 2 colunas desktop */}
      <div className="container mx-auto px-6" style={{ paddingBottom: '5rem' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 420px), 1fr))',
            gap: '2px',
          }}
        >
          {p2.map((product, i) => (
            <ProductCard key={product.id} product={product} index={i + p1.length} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsList;
